import type { IconProps } from './../../models/icon';

export function DeleteIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <g clipPath="url(#a)">
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M1.71436 6H22.2858"
        />
        <path
          fill={secondaryColor}
          d="M4.28564 6H19.7142V21.4286C19.7142 21.8832 19.5335 22.3193 19.2121 22.6407C18.8907 22.9622 18.4546 23.1429 17.9999 23.1429H5.99993C5.54527 23.1429 5.10924 22.9622 4.78774 22.6407C4.46626 22.3193 4.28564 21.8832 4.28564 21.4286V6Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M4.28564 6H19.7142V21.4286C19.7142 21.8832 19.5335 22.3193 19.2121 22.6407C18.8907 22.9622 18.4546 23.1429 17.9999 23.1429H5.99993C5.54527 23.1429 5.10924 22.9622 4.78774 22.6407C4.46626 22.3193 4.28564 21.8832 4.28564 21.4286V6Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M7.71436 5.99997V5.14283C7.71436 4.00619 8.16588 2.91609 8.96961 2.11237C9.77333 1.30865 10.8634 0.857117 12.0001 0.857117C13.1367 0.857117 14.2268 1.30865 15.0305 2.11237C15.8343 2.91609 16.2858 4.00619 16.2858 5.14283V5.99997"
        />
      </g>
      <defs>
        <clipPath id="a">
          <rect width="24" height="24" fill="transparent" />
        </clipPath>
      </defs>
    </svg>
  );
}
